<template>
  <div
    v-if="error"
    v-tippy="{ arrow: true }"
    :content="error"
    class="file-card file-card--error"
  >
    <slot/>
  </div>
  <div
    v-else
    :class="{ 'file-card--success': success }"
    class="file-card"
  >
    <slot/>
  </div>
</template>

<script>
  export default {
    name: 'FileCardContainer',

    props: {
      error: {
        type: String,
        default: null,
      },

      success: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
